import { render, staticRenderFns } from "./SectionConfigurationGrid.vue?vue&type=template&id=aa12a5d0&"
import script from "./SectionConfigurationGrid.vue?vue&type=script&lang=js&"
export * from "./SectionConfigurationGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports